var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"LoadingOverlay"}},[_c('SquareLoader',{attrs:{"color":"#792061","size":"80px"}}),_c('div',{staticClass:"message",domProps:{"textContent":_vm._s(_vm.message)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }